import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardMedia,
  Typography,
  Dialog,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";

const DATA = {
  workspace: [
    { img: "/assets/images/gallery/ClassRoom.jpg", title: "Learning Center" },
    { img: "/assets/images/gallery/FrontOffice.jpg", title: "Front Office" },
    { img: "/assets/images/gallery/Lab1.jpg", title: "AI Lab-1" },
    { img: "/assets/images/gallery/Lab2.jpg", title: "AI Lab-2" },
  ],
  collaborations: [
    { img: "/assets/images/gallery/Logo.jpg", title: "Our Logo" },
    {
      img: "/assets/images/gallery/PECWorkshopPoster.jpg",
      title: "Workshop Poster (Panimalar Engg College)",
    },
    {
      img: "/assets/images/gallery/PECWorkshop1.jpg",
      title: "Hands On Training (Panimalar Engg College)",
    },
    {
      img: "/assets/images/gallery/PECWorkshop2.jpg",
      title: "Last Day (Panimalar Engg College)",
    },
    {
      img: "/assets/images/gallery/pm3.jpg",
      title: "Workshop (Mailam Engg College)",
    },
    { img: "/assets/images/gallery/pm2.jpg", title: "Workshop Inauguration" },
    {
      img: "/assets/images/gallery/pm1.jpg",
      title: "Interaction with Students",
    },
    {
      img: "/assets/images/gallery/aasc1.jpeg",
      title: "Guest Lecturer (AASC)",
    },
    {
      img: "/assets/images/gallery/aasc2.jpeg",
      title: "Interaction with Students",
    },
    {
      img: "/assets/images/gallery/collab1.jpg",
      title: "Chief Guest - Academic Review Meeting",
    },
    {
      img: "/assets/images/gallery/collab2.jpg",
      title: "Guest Lecturer - AI Driven Automation",
    },
    {
      img: "/assets/images/gallery/collab3.jpg",
      title: "Seminar - Programming Trends & Technology",
    },
    {
      img: "/assets/images/gallery/collab4.jpg",
      title: "Seminar About Competitions - Hackathon",
    },
    {
      img: "/assets/images/gallery/collab5.jpg",
      title: "Workshop - AI Driven Automation",
    },
  ],
  celebrations: [
    {
      img: "/assets/images/gallery/Gen8Year1.jpg",
      title: "Genesys 8th Anniversary",
    },
    {
      img: "/assets/images/gallery/Cake8Year.jpg",
      title: "Cake Cutting - 8th Anniversary",
    },
    {
      img: "/assets/images/gallery/AyudhaPooja1.jpg",
      title: "Ayudha Pooja - 2023",
    },
    {
      img: "/assets/images/gallery/AyudhaPooja2.jpg",
      title: "Ayudha Pooja Celebrations",
    },
    {
      img: "/assets/images/gallery/a1.jpg",
      title: "Welcome Event (Mailam Engg College)",
    },
    { img: "/assets/images/gallery/a2.jpg", title: "AI Mania (Winning Event)" },
    {
      img: "/assets/images/gallery/a3.jpg",
      title: "Winners with TCS Delegates",
    },
    { img: "/assets/images/gallery/a4.jpg", title: "Winners with Mentors" },
    {
      img: "/assets/images/gallery/a5.jpg",
      title: "Winners with All Participants",
    },
  ],
};

const GalleryPage = () => {
  const { category } = useParams();
  const images = DATA[category?.toLowerCase()] || [];

  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleOpen = (index) => {
    setSelectedIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box p={4}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: 600, padding: "1.5rem 0", fontFamily: "Archia" }}
      >
        {category?.toUpperCase()} GALLERY
      </Typography>

      <Grid container spacing={6}>
        {images.map((imgData, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card
              sx={{
                cursor: "pointer",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.05)" },
                height: 440,
                display: "flex",
                flexDirection: "column",
              }}
              onClick={() => handleOpen(idx)}
            >
              <CardMedia
                component="img"
                image={imgData.img}
                alt={imgData.title || `Image ${idx + 1}`}
                sx={{
                  flexGrow: 1,
                  height: 0,
                  objectFit: "cover",
                }}
              />

              {imgData.title && (
                <Box p={2}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1.4rem",
                      fontFamily: "Archia",
                      textAlign: "center"
                    }}
                  >
                    {imgData.title}
                  </Typography>
                </Box>
              )}
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Elegant Lightbox */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          handleClose();
        }}
        maxWidth={false}
        PaperProps={{
          sx: {
            bgcolor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
            m: 0,
            width: "100vw",
            maxWidth: "100vw",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            p: 2,
          }}
        >
          {/* Image Wrapper */}
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              minHeight: 0,
              maxWidth: "90vw",
              maxHeight: "100%",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 45,
                right: 18,
                color: "white",
                bgcolor: "rgba(0,0,0,0.4)",
                zIndex: 2,
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.6)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Image */}
            <Box
              component="img"
              src={images[selectedIndex].img}
              alt={images[selectedIndex].title}
              sx={{
                maxWidth: "90vw",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: 3,
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default GalleryPage;
